import { Box, Container, Typography, makeStyles } from "@material-ui/core";

import React from "react";

export const PaymentSettings = (props: any) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Container className={classes.root}>
        <Typography variant="h5" component="h1" color="textPrimary">
          Payment Settings
        </Typography>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  content: {
    display: "flex",
    height: "100%",
    paddingLeft: 0,
    paddingRight: 0,
  },
});
